import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/icon-arrow-left.svg'
import _imports_1 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-4be23cd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-back" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "戻る",
  width: "24",
  height: "24"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "設定完了", -1))
const _hoisted_8 = { class: "p-recommend-inner -is-mail-security-2" }
const _hoisted_9 = { class: "p-mail-security-block" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-mail-security-heading-1 u-mb-10-sp u-mb-16-pc p-mail-security-complete-view__title" }, "変更内容", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "u-text-center u-mb-10-sp u-mb-16-pc p-mail-security-complete-view__description" }, "次の内容で変更いたしました。", -1))
const _hoisted_12 = { class: "p-mail-security-box1" }
const _hoisted_13 = { class: "p-mail-security-email-list2" }
const _hoisted_14 = { class: "p-mail-security-email-list2__content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ログインID", -1))
const _hoisted_16 = { class: "p-mail-security-email-list2__content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス1", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "p-mail-security-email-list2__content" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "メールアドレス2", -1))
const _hoisted_21 = {
  key: 0,
  class: "p-mail-security-block"
}
const _hoisted_22 = { class: "p-mail-security-notice --error u-mb-10-sp u-mb-16-pc p-mail-security-complete-view__error-notice" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "変更いただいたメールアドレスにご本人様確認のメールを送信いたしました。", -1))
const _hoisted_24 = { class: "p-mail-security-box2" }
const _hoisted_25 = { class: "p-mail-security-notice2" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "【マイナビ転職エージェント】メールアドレス1認証のお知らせ", -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "【マイナビ転職エージェント】メールアドレス2認証のお知らせ", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "u-mb-10-sp u-mb-16-pc" }, "このメールに認証のURLがありますので、押下いただき、ご本人様確認を完了してください。", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("メールが届かない際は、下記のFAQページにて対応方法をご確認いただけますと幸いです。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://mynavi-agent.jp/service/faq/mynavi/201.html#section2602",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "マイページに関するFAQ")
], -1))
const _hoisted_36 = { class: "p-mail-security-block" }
const _hoisted_37 = { class: "p-mail-security-buttons-wrap" }
const _hoisted_38 = ["onClick", "aria-disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "メールを再送する", -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン画面に戻る", -1))
const _hoisted_42 = { class: "p-recommend-form__text-7" }
const _hoisted_43 = { class: "l-wrapper_nav" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_46 = [
  _hoisted_45
]

import store from '@/store';
import Loading from '@/components/Loading.vue';
import MailSecurityPopupView from '../mailSecurity/MailSecurityPopupView.vue';
import { RouterLink, useRouter } from 'vue-router';
import { computed, onMounted, ref } from 'vue';
import { MailSecurityResendDetail, MailSecurityResendResponse, MailSecurityUpdateKeyDetail } from '@/types/emailSerurity';
import { postMailSecurityResend } from '@/api/accountEndpoint';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityCompleteView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);
const isShowAlert = ref<boolean>(false);
const messageDisplay = ref('');
const mailSecurityUpdateInfo = ref<MailSecurityUpdateKeyDetail|undefined>();
const isDisabledSubmit = ref(false);
const isAlreadyAuthenticated = ref(false);

const shouldShowAuthGuideSection = computed(() => {
  const info = mailSecurityUpdateInfo.value;

  if (!info?.isEmail2Removed) {
    return true;
  }

  return !!info?.isSendMail1Success || !!info?.isSendMail2Success;
});

onMounted(async () => {
  await store.dispatch('mailSecurity/receive');
  await store.dispatch('mailSecurity/receiveMailSecurityUpdate');
  mailSecurityUpdateInfo.value = store.getters['mailSecurity/mailSecurityUpdateInfo'];
});

const resendVerifyMailSecurity = async () => {
  if (isAlreadyAuthenticated.value || isDisabledSubmit.value) {
    return;
  }
  isDisabledSubmit.value = true;

  isLoading.value = true;
  isShowAlert.value = false;

  try {
    const res = await postMailSecurityResend() as MailSecurityResendResponse;
    const resDetail = res?.detail as MailSecurityResendDetail;
    if (resDetail) {
      if (resDetail.isAlreadyAuthenticated) {
        isAlreadyAuthenticated.value = true;
      } else if (resDetail.isSendMailError) {
        isShowAlert.value = true;
        messageDisplay.value = 'メールアドレスの認証依頼の送信に失敗しました。';
      } else {
        isShowAlert.value = true;
        messageDisplay.value = 'メールを再送しました';
      }
    }
  } 
  catch (_) {
    // eslint-disable-next-line no-empty
  }
  finally {
    isLoading.value = false;
  }

  isDisabledSubmit.value = false;
};

function scrollToTop() {
  domHelperUtils.scrollToTop();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("a", {
            href: "",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).back()), ["prevent"]))
          }, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("ul", _hoisted_13, [
                _createElementVNode("li", null, [
                  _createElementVNode("dl", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("dd", null, _toDisplayString(mailSecurityUpdateInfo.value?.loginId), 1)
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("dl", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("dd", null, _toDisplayString(mailSecurityUpdateInfo.value?.email1), 1)
                  ])
                ]),
                (mailSecurityUpdateInfo.value?.email2 || mailSecurityUpdateInfo.value?.isEmail2Removed)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                      _createElementVNode("dl", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("dd", null, _toDisplayString(mailSecurityUpdateInfo.value?.isEmail2Removed ? '解除されました' : mailSecurityUpdateInfo.value?.email2), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_unref(shouldShowAuthGuideSection))
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, _toDisplayString(isAlreadyAuthenticated.value ? 'このメールアドレスは認証済です。' : 'まだメールアドレス認証は完了しておりません。'), 1),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("p", _hoisted_25, [
                    _createTextVNode(" メール件名： "),
                    (mailSecurityUpdateInfo.value?.isSendMail1Success)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_29))
                      : _createCommentVNode("", true),
                    (mailSecurityUpdateInfo.value?.email2 && mailSecurityUpdateInfo.value?.isSendMail2Success)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _hoisted_33))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_34,
                _hoisted_35
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              (_unref(shouldShowAuthGuideSection))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: _normalizeClass(["p-recommend-button --type-2 --has-icon --width-2", { '--is-disabled': isAlreadyAuthenticated.value }]),
                    href: "",
                    onClick: _withModifiers(resendVerifyMailSecurity, ["prevent"]),
                    "aria-disabled": isAlreadyAuthenticated.value ? 'true' : undefined
                  }, _hoisted_40, 10, _hoisted_38))
                : _createCommentVNode("", true),
              _createVNode(_unref(RouterLink), {
                class: "p-recommend-button --type-2 --has-icon --width-2",
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createBlock(Loading, { key: 0 }))
        : _createCommentVNode("", true),
      (isShowAlert.value)
        ? (_openBlock(), _createBlock(MailSecurityPopupView, {
            key: 1,
            isShowCloseBtnPopup: true,
            isShowSecondClosePopup: true,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (isShowAlert.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_42, _toDisplayString(messageDisplay.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("a", {
        class: "g-pagetop",
        href: "#",
        "aria-label": "ページトップへ戻る",
        onClick: _withModifiers(scrollToTop, ["prevent"])
      }, _hoisted_46, 8, _hoisted_44)
    ])
  ]))
}
}

})